var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgChevronLeft = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_3_",
    transform: "translate(0 -.198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    d: "M90.485 181.381L88.8 179.7l-7.2 7.2 7.2 7.2 1.681-1.681-5.519-5.519z",
    "data-name": "Path 13",
    transform: "translate(-71.994 -172.496)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_25",
    fill: "none",
    d: "M0 0H29V29H0z",
    "data-name": "Rectangle 25",
    transform: "translate(0 .198)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChevronLeft, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/chevron-left.681525bb.svg";
export { ForwardRef as ReactComponent };